<template lang="pug">
fieldset.checkbox
	legend {{legend}}
	p.desc(v-if="description") {{description}}
	div.field(v-for="(option, index) in options" :index="index" :key="option")
		input(type="checkbox" v-model="value" :value="option" @change="fieldUpdated" :disabled="disabled")
		label {{option.option}}
		span.on(v-if="value.find(v => v.value == option.value)") {{checkedLabel}}
		span.off(v-else) {{uncheckedLabel}}
</template>

<script>
export default {
	name: 'FieldCheckbox',
	props: {
		modelValue: {
			type: Array,
			required: true,
		},
		options: {
			type: Array,
			required: true,
			validator: (value) => {
				const hasOptionKey = value.every((option) => Object.keys(option).includes('option'));
				const hasValueKey = value.every((option) => Object.keys(option).includes('value'));
				
				return hasOptionKey && hasValueKey;
			},
		},
		legend: {
			type: String,
			default: '',
		},
		description: {
			type: String,
			default: '',			
		},
		checkedLabel: {
			type: String,
			default: 'Yes',
		},
		uncheckedLabel: {
			type: String,
			default: 'No',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['fieldUpdated','update:modelValue'],
	computed: {
		value: {
			get() {
				return this.modelValue;
			},
			set(value) {
				this.$emit('update:modelValue', value);
			}
		},
	},
	methods: {
		fieldUpdated() {
			this.$emit('fieldUpdated');
		},
	},
}
</script>

<style lang="scss">
</style>
